import React, {useEffect, useState} from 'react'
import take from 'lodash/take';
import PropTypes from 'prop-types';
import './styles.scss';
import {publisherRecircClick, publisherRecircScroll} from '../../ctas';
import TrackedLink from '../TrackedLink/Element'
import analyticsTriggers from '../../analytics/triggers';
import VisibilitySensor from '../../../Components/VisibilitySensor';
import {fireGtagEvent, getEventLabel} from '../../helpers/gtag-helpers';
import GaImpressionTrigger from '../GaImpressionTrigger/Element';
import {getPublisherRecs} from '../../api'

const MODULE_NAME = "syndicated_publisher";

const Publisher = ({recommendationName, logoUrl}) => (
    <React.Fragment>
      {logoUrl ? <img className="publisher-logo" src={logoUrl} alt={recommendationName}/> : null}
      <p className="title">More from {recommendationName}</p>
    </React.Fragment>
)

const RelatedItem = ({item, targetUrl = '', title, saveCount = null, index, model, recId, pageLoadId, synArticleId}) => {
  const ArticleLink = TrackedLink({...publisherRecircClick, index});
  const {name, category, nonInteraction, label} = publisherRecircScroll;

  const handleClick = () => {
    analyticsTriggers.recitClick(
        model,
        recId,
        pageLoadId,
        synArticleId,
        MODULE_NAME,
        index,
        item.item_id
    )
  }

  return (
      <VisibilitySensor onVisible={() => {
        fireGtagEvent(name, getEventLabel(label, index), category, nonInteraction);
        analyticsTriggers.recitImpression(model, recId, pageLoadId, synArticleId, MODULE_NAME, index, item.item_id);
      }}>
        <li className="article-item">
          <ArticleLink href={targetUrl} onClick={handleClick} className="outgoing-links-article-title" target="_blank">{title}</ArticleLink>
          {saveCount && <div className="pocket-saves-line">{saveCount.toLocaleString()} Saves</div>}
        </li>
      </VisibilitySensor>
  );
}

const PublisherLinks = ({synArticleId, resolvedId, pageLoadId, publisher, initialResponse}) => {
  const [articles, updateArticles] = useState(initialResponse.recommendations);
  const [model, updateModel] = useState(initialResponse.model);
  const [recId, updateRecId] = useState(initialResponse.rec_id);

  if (resolvedId) {
    useEffect(() => {
      getPublisherRecs(
          resolvedId,
          (response) => {
            const {recommendations, model, rec_id} = response;

            updateModel(model);
            updateArticles(recommendations);
            updateRecId(rec_id);
          },
          (error) => {
            // TODO: meet w FE team to talk about error handling in our apps here
            // https://getpocket.atlassian.net/wiki/spaces/FRONT/pages/900858150/Projects
          },
      )
    }, []);
  }

  if (!articles.length || !publisher) {
    return null;
  }

  return (
      <aside className="outgoing-links">
        <Publisher {...publisher} />
        <ul>
          {take(articles, 3).map((a, index) => {
            const { save_count: saveCount, target_url: targetUrl, item} = a;
            return (
                <RelatedItem
                    key={item.item_id}
                    item={item}
                    title={item.title}
                    targetUrl={targetUrl}
                    saveCount={saveCount}
                    index={index}
                    synArticleId={synArticleId}
                    model={model}
                    recId={recId}
                    pageLoadId={pageLoadId}
                />
            )
          })}
        </ul>
      </aside>
  )
};

PublisherLinks.propTypes = {
  synArticleId: PropTypes.string.required,
  resolvedId: PropTypes.string.required,
  pageLoadId: PropTypes.string.required,
  initialResponse: PropTypes.shape({}),
};

PublisherLinks.defaultProps = {
  initialResponse: {recommendations: []},
};

export default PublisherLinks;
